import Logo from '../../components/ui/logo/Logo';
import styles from './fail-page.module.sass';
import FailPng from '../../assets/images/fail.png';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FailPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.FailPageWrapper}>
      <div>
        <Logo />
      </div>
      <div className={styles.FailPageInfo}>
        <div>
          <div className={styles.FailPageTitle}>
            {t('additionalPages.error')}
          </div>
          <div className={styles.FailPageParagraph}>
            {t('additionalPages.somethingWentWrong')}
          </div>
          <div className={styles.FailPageMessage}>
            {t('additionalPages.serviceTemporarilyDown')}
          </div>
          <Link to="/">
            <div className={styles.FailPageBtn}>
              {t('additionalPages.goHome')}
            </div>
          </Link>
        </div>
        <div className={styles.FailPagePng}>
          <img src={FailPng} height="auto" width="100%" />
        </div>
      </div>
    </div>
  );
};

export default FailPage;
